const CR = {
  countryConfig: {
    IBAN: {
      visible: false,
      required: false,
    },
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      visible: true,
      required: true,
    },
    accountHolderDocType: {
      visible: false,
      required: false,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
    accountNumber: {
      label: "bankDetails.accountNumber",
      visible: true,
      required: true,
    },
    bankName: {
      label: "bankDetails.bankName",
      visible: true,
      required: true,
    },
    swift: {
      label: "bankDetails.swift",
      visible: true,
      required: true,
    },
  },
};
export { CR };
